import { canonicalFitnessLocalWorkout, type FitnessLocalWorkoutEnvelope } from './fitnessLocalWorkoutDomain.ts';

export const FITNESS_DRAFT_RESTORE_TOOL = 'propose_fitness_draft_restore';
export interface FitnessDraftRestoreArgs { action: 'restore_saved_draft'; snapshot: FitnessLocalWorkoutEnvelope }
const object = (value: unknown): value is Record<string, unknown> => value !== null && typeof value === 'object' && !Array.isArray(value);
const invalid = (): never => { throw new Error('invalid_fitness_draft_restore'); };

/** A device projection stages a paused restore review, never execution authority. */
export function canonicalRestoreArgs(input: unknown, owner: string, now: Date = new Date()): FitnessDraftRestoreArgs {
  if (!object(input) || Object.keys(input).length !== 2 || !Object.prototype.hasOwnProperty.call(input, 'action') || !Object.prototype.hasOwnProperty.call(input, 'snapshot') || input.action !== 'restore_saved_draft') return invalid();
  const snapshot = canonicalFitnessLocalWorkout(input.snapshot, owner, now);
  if (snapshot.status !== 'available' || snapshot.summary === null) return invalid();
  return { action: 'restore_saved_draft', snapshot };
}
